"use client";

import { cn } from "@/lib";
import AppContainer from "../appContainer";
import Team1Image from "@public/team1.webp";
import Image from "next/image";
import { ourValues } from "@/constants";
import ValueCard from "./ValueItem";
import { useTranslations } from "next-intl";

interface ValuesSectionProps {
  className?: string;
}

const ValuesSection = ({ className }: ValuesSectionProps) => {
  const t = useTranslations();
  return (
    <section
      className={cn(
        "bg-primary-main h-[466px] w-full bg-[url(/wavy-pattern.svg)] bg-cover py-10 text-white lg:h-[566px]",
        className,
      )}
    >
      <AppContainer className="h-full">
        <header
          className={cn(
            "mt-3 flex w-full flex-col justify-center gap-3 sm:mt-5 sm:gap-5",
          )}
        >
          <h3 className="flex items-center justify-center text-center font-bold xl:text-xl">
            {t("aboutUs.values.title")}
          </h3>
          <h3
            className={cn(
              "flex items-center justify-center text-center text-xs leading-[25px]! font-normal whitespace-pre-line sm:text-sm xl:text-base",
            )}
          >
            {t("aboutUs.values.description")}
          </h3>
        </header>
      </AppContainer>
      <AppContainer className={cn("h-full")}>
        <div className="shadow-main relative z-10 mx-auto mt-[-210px] w-full overflow-hidden rounded-xl bg-white sm:h-[350px] sm:max-w-[700px] lg:mt-[-310px] lg:h-[400px] lg:max-w-[900px] xl:h-[450px] xl:max-w-[1000px]">
          <div className="flex h-full flex-col sm:flex-row">
            <div
              className={cn(
                "flex shrink-0 basis-1/2 flex-col justify-around gap-4 px-5 py-6 sm:gap-0 lg:px-10 lg:py-12",
              )}
            >
              {ourValues.map((value, index) => (
                <ValueCard
                  key={index}
                  title={t(value.title as any)}
                  description={t(value.description as any)}
                  icon={value.icon}
                />
              ))}
            </div>
            <figure className={cn("basis-1/2")}>
              <Image
                className={cn("size-full object-cover")}
                alt="Team2Image"
                title="Team2Image"
                src={Team1Image}
              />
            </figure>
          </div>
        </div>
      </AppContainer>
    </section>
  );
};

export default ValuesSection;
